(() => {
  const root = document.querySelector('[data-preet-first-visit]');
  if (!root || root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';

  const dialog = root.querySelector('.preet-first-visit__dialog');
  const ageYes = root.querySelector('[data-pfv-age-yes]');
  const ageNo = root.querySelector('[data-pfv-age-no]');
  const ageMessage = root.querySelector('[data-pfv-age-message]');
  const skip = root.querySelector('[data-pfv-skip]');
  const enter = root.querySelector('[data-pfv-enter]');
  const form = root.querySelector('#PreetFirstVisitForm');
  const formMessage = root.querySelector('[data-pfv-form-message]');
  const email = root.querySelector('#PreetFirstVisitEmail');
  const designMode = root.dataset.designMode === 'true' || Boolean(window.Shopify && Shopify.designMode);
  const suppressLegacyPopup = root.dataset.suppressLegacyPopup === 'true';
  const legacyPhrase = (root.dataset.legacyPopupPhrase || 'hold up').trim().toLowerCase();
  const legacyOfferPhrase = (root.dataset.legacyOfferPhrase || 'free shipping').trim().toLowerCase();
  const keys = {
    age: 'preet-first-visit-age-day-v2',
    complete: 'preet-first-visit-complete-day-v2'
  };

  function localDayKey(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const storage = {
    get(key) {
      try { return localStorage.getItem(key) || ''; } catch (_) { return ''; }
    },
    set(key) {
      try { localStorage.setItem(key, localDayKey()); } catch (_) {}
    },
    valid(key) {
      return this.get(key) === localDayKey();
    }
  };

  let lastFocused = null;
  const focusableSelector = 'button:not([disabled]),input:not([disabled]),a[href],select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function suppressLegacyMarketingPopup(scope = document) {
    if (!suppressLegacyPopup || !legacyPhrase || !legacyOfferPhrase) return;
    const candidates = scope.querySelectorAll?.('[role="dialog"], [data-testid*="form"], div[class*="kl-private-reset-css"]') || [];
    candidates.forEach((candidate) => {
      if (root.contains(candidate)) return;
      const text = (candidate.textContent || '').replace(/\s+/g, ' ').toLowerCase();
      if (!text.includes(legacyPhrase) || !text.includes(legacyOfferPhrase)) return;
      let target = candidate;
      while (target.parentElement && target.parentElement !== document.body) {
        const parentText = (target.parentElement.textContent || '').replace(/\s+/g, ' ').toLowerCase();
        if (!parentText.includes(legacyPhrase) || !parentText.includes(legacyOfferPhrase)) break;
        target = target.parentElement;
      }
      target.setAttribute('data-preet-suppressed-popup', 'true');
      target.setAttribute('aria-hidden', 'true');
      target.style.setProperty('display', 'none', 'important');
    });
  }

  if (suppressLegacyPopup) {
    suppressLegacyMarketingPopup(document);
    const legacyObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) suppressLegacyMarketingPopup(node);
      }));
    });
    legacyObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function showStep(name) {
    root.classList.toggle('is-offer', name === 'offer');
    root.classList.toggle('is-success', name === 'success');
    root.querySelectorAll('[data-pfv-step]').forEach((step) => {
      const active = step.dataset.pfvStep === name;
      step.classList.toggle('is-active', active);
      step.setAttribute('aria-hidden', String(!active));
    });
    root.querySelectorAll('[data-pfv-progress]').forEach((item) => {
      item.classList.toggle('is-active', item.dataset.pfvProgress === (name === 'age' ? 'age' : 'offer'));
    });
    requestAnimationFrame(() => {
      const activeStep = root.querySelector(`[data-pfv-step="${name}"]`);
      const focusTarget = name === 'offer'
              ? (window.matchMedia('(max-width: 899px)').matches ? activeStep?.querySelector('h2') : email)
                      : activeStep?.querySelector('button,input');
                            if (focusTarget?.matches('h2')) focusTarget.setAttribute('tabindex', '-1');
      focusTarget?.focus({ preventScroll: true });
    });
  }

  function openJourney() {
    lastFocused = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('preet-first-visit-open');
    document.body.classList.add('preet-first-visit-open');
    const startAtOffer = !designMode && storage.valid(keys.age) && !storage.valid(keys.complete);
    showStep(startAtOffer ? 'offer' : 'age');
    requestAnimationFrame(() => dialog?.focus({ preventScroll: true }));
  }

  function closeJourney() {
    storage.set(keys.complete);
    root.classList.add('is-closing');
    document.documentElement.classList.remove('preet-first-visit-open');
    document.body.classList.remove('preet-first-visit-open');
    setTimeout(() => {
      root.hidden = true;
      root.classList.remove('is-closing');
      lastFocused?.focus?.({ preventScroll: true });
    }, 420);
  }

  if (!designMode && !storage.valid(keys.complete)) openJourney();

  ageYes?.addEventListener('click', () => {
    storage.set(keys.age);
    if (ageMessage) {
      ageMessage.classList.remove('is-error');
      ageMessage.textContent = ageMessage.dataset.original || ageMessage.textContent;
    }
    const paidParams = new URLSearchParams(window.location.search);
    const isPaidMetaVisitor =
      paidParams.has('fbclid') ||
      ['facebook', 'instagram', 'meta'].includes((paidParams.get('utm_source') || '').toLowerCase()) ||
      ['paid_social', 'paidsocial'].includes((paidParams.get('utm_medium') || '').toLowerCase());

    if (isPaidMetaVisitor) closeJourney();
    else showStep('offer');
  });

  if (ageMessage) ageMessage.dataset.original = ageMessage.textContent.trim();
  ageNo?.addEventListener('click', () => {
    if (!ageMessage) return;
    ageMessage.classList.add('is-error');
    ageMessage.textContent = root.querySelector('[data-pfv-age-no]')?.closest('[data-pfv-step]')?.dataset.decline || "You must be 21 or older to enter Preet's Liquors.";
    ageNo.animate([
      { transform: 'translateX(0)' }, { transform: 'translateX(-5px)' },
      { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }
    ], { duration: 260, easing: 'ease-out' });
  });

  skip?.addEventListener('click', closeJourney);
  enter?.addEventListener('click', closeJourney);
  email?.addEventListener('focus', () => root.classList.add('is-email-focused'));
  email?.addEventListener('blur', () => root.classList.remove('is-email-focused'));

  form?.addEventListener('submit', async (event) => {
    if (!email?.checkValidity()) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const original = submit?.querySelector('span')?.textContent || '';
    if (submit) submit.disabled = true;
    if (submit?.querySelector('span')) submit.querySelector('span').textContent = 'Joining…';
    if (formMessage) formMessage.textContent = '';

    if (designMode) {
      showStep('success');
      if (submit) submit.disabled = false;
      if (submit?.querySelector('span')) submit.querySelector('span').textContent = original;
      return;
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Unable to join');
      storage.set(keys.complete);
      showStep('success');
    } catch (_) {
      if (formMessage) formMessage.textContent = 'Please try again, or continue into the cellar.';
    } finally {
      if (submit) submit.disabled = false;
      if (submit?.querySelector('span')) submit.querySelector('span').textContent = original;
    }
  });

  root.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const active = root.querySelector('[data-pfv-step].is-active');
    const items = [...(active?.querySelectorAll(focusableSelector) || [])].filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (designMode) {
      document.documentElement.classList.remove('preet-first-visit-open');
      document.body.classList.remove('preet-first-visit-open');
      root.hidden = true;
      return;
    }
    if (event.target.querySelector?.('[data-preet-first-visit]')) location.reload();
  });
})();
